<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="guardarDeclaracionSuplementaria()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
            <button *ngIf="visibilityBuscadorDeclaracion" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="onSearchDeclaracionSuplementaria()"><i class="fa fa-search"></i> Buscar Declaración Adic.</button>
            <div *ngIf="declCeNoGuardada" class="nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> La Declaración Adicional no ha sido guardada.</label>
            </div>
            <div *ngIf="noHayDeclActivas" class="nota-info">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> No se han encontrado Declaraciones Adicionales activas predefinidas para esta campaña</label>
            </div>
        </div>
    </nav>

    <app-declaracion-adicional-popup (selected)="onAcceptDialogDeclaracionAdicional($event)"></app-declaracion-adicional-popup>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline">Declaración Adicional {{solicitudDeclaracionSuplementariaEx.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{solicitudDeclaracionSuplementariaEx.CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudDeclaracionSuplementariaEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudDeclaracionSuplementariaEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudDeclaracionSuplementariaEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudDeclaracionSuplementariaEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudDeclaracionSuplementariaEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudDeclaracionSuplementariaEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{solicitudDeclaracionSuplementariaEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudDeclaracionSuplementariaEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudDeclaracionSuplementariaEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudDeclaracionSuplementariaEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn">
                    <div class="card-header">
                        <!--<strong>Tasas</strong>-->
                    </div>
                    <div class="card-body-detalle">

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-12">
                                <!-- required-field -->
                                <label class="col-form-label" for="inpDeclaracionSuplementaria">Declaración Adicional</label>
                                <textarea [readonly]="readonlyDeclaracion" formControlName="DeclaracionSuplementaria" name="DeclaracionSuplementaria" title="" class="form-control"
                                          id="inpDeclaracionSuplementaria" type="text" value="" autoResize="autoResize" rows="12" maxlength="50000"></textarea>

                                <!--<div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('DeclaracionSuplementaria','required')">
                        La Declaración Adicional es obligatoria
                    </div>-->
                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('DeclaracionSuplementaria','pattern')">
                                    Formato incorrecto.
                                </div>

                            </div>

                        </div>

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-12">
                                <!-- required-field -->
                                <label class="col-form-label" for="inpDeclaracionSuplementariaInspector">Declaración Adicional Inspector</label>
                                <textarea formControlName="DeclaracionSuplementariaInspector" name="DeclaracionSuplementariaInspector" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('DeclaracionSuplementariaInspector')"
                                          id="inpDeclaracionSuplementaria" type="text" value="" autoResize="autoResize" rows="12" maxlength="50000"></textarea>

                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('DeclaracionSuplementariaInspector','required')">
                                    La Declaración Suplementaria es obligatoria
                                </div>
                                <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('DeclaracionSuplementariaInspector','pattern')">
                                    Formato incorrecto.
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
